import { render } from "./DomainsTable.vue?vue&type=template&id=32a6e020&scoped=true"
import script from "./DomainsTable.vue?vue&type=script&lang=js"
export * from "./DomainsTable.vue?vue&type=script&lang=js"

import "./DomainsTable.vue?vue&type=style&index=0&id=32a6e020&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a6e020"]])

export default __exports__